import RootPage from "components/layout/RootPage";
import "styles/global.scss";



function App() {
  return (
    <RootPage />
  );
}

export default App;